<!--
 * @Author: 孙威
 * @LastEditors: majungcy majun18705161998@163.com
 * @description: page description
 * @Date: 2022-01-19 11:08:50
 * @LastEditTime: 2022-07-18 16:15:50
-->
<template>
  <div v-show="show" class="add-keyword">
    <Header :config="headConfig" />
    <div class="keyword-main">
      <van-cell-group class="select-all-items mt-8 mb-8">
        <SelectStore :config="storeConfig" @selectApp="selectStore" />
        <select-app
          ref="appSelect"
          :platform="addForm.platform ? addForm.platform : 1"
          :app-id="addForm.appId"
          :app-detail="appDetail"
          :app-first="appFirst"
          page-type="keyword"
          @getAppInfo="getAppInfo"
        />
        <select-country-detail
          :platform="addForm.platform ? addForm.platform : 1"
          :region="addForm.region"
          page-type="keyword"
          @getSelectCountry="getSelectCountry"
        />
      </van-cell-group>

      <div class="keyword-input">
        <div class="title">Keywords</div>
        <div
          class="input-area flex align-center"
          :style="keywordList.length > 0 ? 'margin-top:0;' : 'margin-top:10px;'"
        >
          <van-tag
            v-for="word in keywordList"
            :key="word"
            class="input-tag"
            color="#dfddff"
            text-color="#6153FF"
            closeable
            size="medium"
            @close="deleteTagKeyword(word)"
          >
            {{ word }}
          </van-tag>
          <van-field
            ref="saveTagInput"
            v-model="addForm.keywords"
            autofocus
            style="margin-top: 8px"
            :style="keywordList.length > 0 ? { 'max-width': '200px' } : ''"
            label=""
            rows="1"
            :type="keywordList.length <= 0 ? 'textarea' : ''"
            maxlength="100"
            :placeholder="
              keywordList.length <= 0
                ? 'You can add keywords one by one separated by pressing Enter'
                : ''
            "
            @blur="blurInput"
            @update:model-value="addTagKeyword"
          />
        </div>
        <div class="text-area-count">{{ keywordList.length }} / 100</div>
        <van-button
          class="add-btn"
          color="#6153FF"
          @mousedown="addKeywordBtn"
        >{{ isFromUserGuidance ? 'Save Draft' : 'Add' }}</van-button>
      </div>

      <div class="keyword-table">
        <div class="title">Recommended Keywords</div>
        <!-- <div>{{ addForm }}</div> -->
        <div class="table-class" v-if="!isMaintain">
          <table :class="{'keyword-table':addForm.platform!==1}" cellpadding="2" cellspacing="0" v-if="keywordForm && list.length > 0">
            <thead>
              <tr>
                <td style="width: 20px">
                  <van-checkbox
                    v-model="checkAll"
                    shape="square"
                    @change="selectAll"
                    class="check-box-class"
                    :class="{
                      'not-all':
                        keywordList.some(
                          (item) => item.isCheck
                        ) &&
                        keywordList.some(
                          (item) => !item.isCheck
                        ),
                    }"
                  />
                </td>
                <td class="titleOne">Keywords</td>
                <td class="titleOne">Ranking</td>
                <td class="titleOne">
                  Score
                </td>
                <td class="titleOne">Search Volume</td>
                <td class="titleOne" v-if="addForm.platform!==1">Popularity</td>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in list" :key="item">
                <td class="state">
                  <!-- <van-button
                    v-if="item.state === 0"
                    round
                    type="primary"
                    size="mini"
                    class="plusBtn plusButton"
                    icon="plus"
                    @click="handleEdit(index, item)"
                  />
                  <van-button
                    v-if="item.state === 1"
                    round
                    type="success"
                    size="mini"
                    class="plusBtn sucessBtn"
                    @click="handleEdit(index, item)"
                    icon="success"
                  /> -->
                  <van-checkbox shape="square" v-model="item.state" @click="handleEdit(index, item)" />
                </td>
                <td>{{ item.keyword }}</td>
                <td>
                  <WordRankCell
                    v-if="item.keyword.length > 0"
                    :word-info="item"
                    :show-diff="false"
                    :show-rank-text="false"
                    class="word-rank-cell justify-center"
                    @rank="rankDetail"
                    :rank-word="true"
                  />
                </td>
                <td>
                  <span v-if="item.score !== -1">{{ item.score }}</span>
                  <span v-else>-</span>
                </td>
                <td>
                  <WordRankCell
                    :word-info="item"
                    class="word-rank-cell justify-center"
                    @wordRank="rankDetail"
                    :hot-word="true"
                  />
                </td>
                <td v-if="addForm.platform!==1">
                  <WordRankCell
                    :word-info="item"
                    class="word-rank-cell justify-center"
                    @wordRank="rankDetail"
                    :pop-word="true"
                  />
                </td>
              </tr>
              <tr>
                <td colspan="5" @click="goAppRank" class="app-rank-more">
                  More>
                </td>
              </tr>
            </tbody>
          </table>
          <div v-else>
            <img src="../../../../assets/images/nodata.svg" alt="no-data">
            <div v-if="!isFromUserGuidance" class="no-data-text">
              Notice:No keywords recommended. Please go to
              <span class="active" @click="go">"Package (Direct) Installs"</span>
              page and place order according to our suggestions listed in "Terms".
            </div>
            <div v-else class="no-data-text">
              Notice:No keywords recommended. Go to 
              <span class="active" @click="goService">Services</span> 
              page to see more services.
            </div>
          </div>
        </div>
        <div v-if="isMaintain">
          <div class="maintain-wrap">
            <img src="images/maintain/maintain.svg" alt="">
            <div class="maintain-text">
              Data is unavailable at the moment, please try it later or contact your personal manager.
            </div>
          </div>
        </div>
      </div>
    </div>
    <Rank ref="rank" />
    <Loading :show="loading" />
  </div>
</template>

<script>
import {
  ref,
  reactive,
  onMounted,
  computed,
  onBeforeMount,
  getCurrentInstance,
  toRefs,
  inject
} from "vue";
import { post } from "src/utils/request.js";
import { useRouter } from "vue-router";
import { getWordRank } from "model/common";
import WordRankCell from "components/Rank/WordRankCell";
import Loading from "../../../order/components/Loading";
import { addKeyword, getAppList } from "model/mine";
import { Dialog,Toast } from "vant";
import event from "utils/eventBus";
import SelectCountryDetail from "../../../order/components/SelectCountryDetail.vue";
export default {
  components: {
    Loading,
    SelectCountryDetail,
    WordRankCell,
  },
  props: {
    keywordForm: {
      type: Object,
      default: () => null,
    },
    appDetail: {
      type: Object,
      default: () => null,
    },
  },
  setup(props, { emit }) {
    const { big_data_error_num } = inject('error')
    const isMaintain = ref(false)
    const headConfig = {
      callBackName: "choseBackKeyowrd",
      type: "other",
      title: "Add Keywords",
    };

    let loading = ref(false);
    const router = useRouter();

    const addForm = reactive({
      region: null,
      platform: null, //默认为Google
      appId: null,
      keywords: "",
      words: [],
    });
    
    //关键词
    const checkAll = ref(false)

    // table列表数据;
    const newData = reactive({
      list: [],
    });
    let appFirst = ref({});
    let googleApp = ref({});
    let iosApp = ref({});
    const instance = getCurrentInstance();
    const api = instance.appContext.config.globalProperties.$url;
    //根据platform获取对应app列表的第一个app
    const getPlatformApp = (platform) => {
      if (platform === 1) {
        if (!googleApp.value.count) {
          Object.keys(appFirst.value).forEach((item) => {
            appFirst.value[item] = null;
          });
        } else {
          Object.assign(appFirst.value, googleApp.value.list[0].appInfo);
        }
      } else {
        if (!iosApp.value.count) {
          Object.keys(appFirst.value).forEach((item) => {
            appFirst.value[item] = null;
          });
        } else {
          Object.assign(appFirst.value, iosApp.value.list[0].appInfo);
        }
      }
    };
    const addFormInit = async () => {
      addForm.platform = props.keywordForm.platform
        ? parseInt(props.keywordForm.platform)
        : 1;
      googleApp.value = await getAppList({ platform: 1 });
      iosApp.value = await getAppList({ platform: 2 });
      getPlatformApp(addForm.platform);
      //根据是否选择store来设置数据
      if (props.keywordForm.platform) {
        addForm.region = props.keywordForm.region ? props.keywordForm.region : null;
        (addForm.region);
        addForm.appId = props.keywordForm.appId ? props.keywordForm.appId : null;
        appSelect.value.appInfoInit();
      } else {
        addForm.region = appFirst.value
          ? appFirst.value.region
            ? appFirst.value.region
            : "US"
          : null;
        addForm.appId = appFirst.value ? appFirst.value.id : null;
        appSelect.value.getAppFirst();
      }
    };

    let keywordList = reactive([]);

    //获取store，并查找对应的keyword
    const selectStore = async (val) => {
      if (val !== addForm.platform) {
        getPlatformApp(val);
        addForm.region = appFirst.value
          ? appFirst.value.region
            ? appFirst.value.region
            : "US"
          : null;
        addForm.appId = appFirst.value ? appFirst.value.id : null;
        appSelect.value.getAppFirst();
      }
      addForm.platform = val;
    };
    //获取appInfo，并查找对应的keyword
    const getAppInfo = async (val) => {
      addForm.appId = val.id;
    };
    //获取选中的国家信息，并查找对应的keyword
    const getSelectCountry = async (val) => {
      addForm.region = val;
    };

    const handleEdit = (index, item) => {
      if (!keywordList.includes(item.keyword)) {
        keywordList.push(item.keyword);
        item.state = 1;
      } else {
        const itemIndex=keywordList.findIndex(childItem=>childItem===item.keyword)
        if(itemIndex>=0){
          keywordList.splice(itemIndex,1)
        }
        item.state = 0;
      }
    };

    //输入框添加关键字
    const saveTagInput = ref(null);
    const addTagKeyword = () => {
      let word = addForm.keywords;
      if (word) {
        word = word.trim();
        const a = word.indexOf(",");
        word = word.replace(/\s+/g, " ").replace(",", "");
        if (word.match(/^[ ]*$/) || a === 0) {
          addForm.keywords = "";
        } else if (a > 0) {
          if (!keywordList.includes(word.replace(",", ""))) {
            keywordList.push(word);
          }
          addForm.keywords = "";
        }
      }
    };
    //失焦事件
    const blurInput = () => {
      let word = addForm.keywords;
      if (word) {
        if (!keywordList.includes(word)) {
          word = word.replace(/\s+/g, " ");
          word = word.trim();
          keywordList.push(word);
          addForm.keywords = "";
        } else {
          addForm.keywords = "";
        }
      }
    };
    // 跳转事件
    const go = () => {
      router.push({
        path: "/wap/campaign",
        // name: 'PACKAGE',
        query: {
          serviceType: "DIRECT_INSTALL",
          appId: addForm.appId,
          platform: addForm.platform,
          region: addForm.region,
        },
      });
    };

    const goService = () => {
      show.value = false;
    }
    //添加关键词
    const addKeywordBtn = async () => {
      let reqParamsWords = ""
      if (addForm.appId) {
        if (addForm.region) {
          if (keywordList.length || addForm.keywords.length) {
            reqParamsWords =  JSON.stringify(addForm.keywords
              ? [...keywordList, addForm.keywords.trim()]
              : keywordList)
            
            await addKeyword({
              platform: parseInt(addForm.platform),
              appId: addForm.appId,
              region: addForm.region,
              words: addForm.keywords
                ? [...keywordList, addForm.keywords.trim()]
                : keywordList,
            });
            addForm.keywords = "";
            keywordList.length = 0;
            show.value = false;
            emit("refreshList");
            Toast({
              message: 'Add keywords successfully.',
              position: 'top',
            });
          } else {
            Dialog.alert({
              message: "Please fill in keywords",
              confirmButtonText: "Confirm",
            }).then(() => {
              // on close
            });
          }
        } else {
          Dialog.alert({
            message: "Please select country",
            confirmButtonText: "Confirm",
          }).then(() => {});
        }
      } else {
        if (!addForm.appId) {
          Dialog.alert({
            message: "Please select your application first",
            confirmButtonText: "Confirm",
          }).then(() => {
            // on close
          });
        }
      }
      // location.reload();
      if ( !isFromUserGuidance.value ) {
        router.push({
          path: "/wap/mine/my-keywords"
        });
      } else {
        router.push({
          path: "/wap/campaign",
          query: {
            serviceType: "KEYWORD_INSTALL",
            installWords: reqParamsWords,
            openType: 'userGuidanceDialog'
          }
        });
      }
      
    };

    //输入框删除tag
    const deleteTagKeyword = (word) => {
      keywordList.splice(keywordList.indexOf(word), 1);
      newData.list.forEach((item) => {
        if (item.keyword === word) {
          item.state = 0;
        }
      });
    };
    
    const searchAgain = async (val) => {
      if (val.platform && val.appId && val.region) {
        const res = await post(api.GET_RECOMMENDWORDS, {
          platform: val.platform,
          appId: val.appId,
          region: val.region,
        });
        
        if (res.data === big_data_error_num) {
          isMaintain.value = true
          return 
        }

        if (res.data) {
          newData.list = res.data.map((item) => {
            return {
              ...item,
              compareTs: item.ts,
              loading: true,
              rank: null,
              state: 0,
              region: props.keywordForm.region,
              appId: props.keywordForm.appId,
              platform: props.keywordForm.platform,
              word: item.keyword,
              showRefresh: true,
            };
          });
        }
      } else {
        newData.list = [];
      }
    };
    const rank = ref(null);
    const rankDetail = (config) => {
      rank.value.showPopup(config);
    };

    const show = ref(false);
    const openType = ref('');
    const openAddKeyword = (appInfo, data = {}) => {
      addForm.appInfo = appInfo ? appInfo : null
      show.value = true;
      openType.value = data.openType
    };

    const isFromUserGuidance = computed(() => {
      return openType.value === 'userGuidanceDialog'
    });
    
    //定时器
    let getWordRankTimer = ref(null);
    onMounted(async () => {
      if (props.keywordForm) {
        addForm.platform = props.keywordForm.platform;
        addForm.appId = props.keywordForm.appId;
        addForm.region = props.keywordForm.region;
        searchAgain(props.keywordForm)
      } else {
        newData.list = [];
      }
      getWordRankTimer.value = setTimeout(async () => await getWordRankInit(), 1000);
    });
    onMounted(() => {
      event.$on("choseBackKeyowrd", () => {
        location.reload();
        // show.value = false
      });
    });
    onBeforeMount(() => {
      event.$off("choseBackKeyowrd");
    });
    //store组件默认值
    const storeConfig = computed(() => {
      return {
        appInfo: addForm.appInfo,
        active: props.keywordForm.platform ? parseInt(props.keywordForm.platform) : 1,
        eventName: "selectApp",
      };
    });

    const appSelect = ref(null);

    const getShow = () => {
      return false;
    };
    //刷新关键词
    const getWordRankInit = async () => {
      // 收集需要获取排名的数据
      const words = newData.list.filter((i) => i.loading && i.keyword.trim().length > 0);
      if (words.length > 0) {
        const wordsWithTs = words.map((i) => {
          return { word: i.word, compareTs: i.ts };
        });
        const rankData = await getWordRank(api.GET_WORD_RANK, {
          platform: words[0].platform,
          appId: words[0].appId,
          region: words[0].region,
          words: wordsWithTs,
        });
        const rankWords = rankData ? rankData.data : [];
        for (const newWordStr in rankWords) {
          const newWord = rankWords[newWordStr];
          words
            .filter((w) => w.word === newWordStr)
            .forEach((old) => {
              if (newWord.ts > old.ts || newWord.rank) {
                old.rank = newWord.rank;
                old.diff = newWord.diff;
                old.ts = newWord.ts;
                old.loading = false;
              }
            });
        }
      }
      if (getWordRankTimer.value) {
        // 如果定时器没了，说明组件被销毁了，就不要继续查询了
        getWordRankTimer.value = setTimeout(async () => await getWordRankInit(), 1000);
      }
    };

    const goAppRank = () => {
      const info = addForm
      const url = 'https://www.appranking.com/ranked-keywords/' + info.appId + '/' + info.region + '/' + (info.platform === 2 || info.platform === 3 ? 'as' : 'gp')
      window.open(url)
    }
    //全选或者全不选
    const selectAll = (check) => {
      let currentCheck=check
      if(newData.list.some((item) => item.isCheck)&&newData.list.some((item) => !item.isCheck)){
        currentCheck=true//部分选中状态
        checkAll.value=currentCheck
      }
      newData.list.forEach((item) => {
        item.state=currentCheck ? 1 : 0
        if (currentCheck) {
          if (keywordList.indexOf(item.keyword) === -1) {
            item.diff !== 'out' && keywordList.push(item.keyword)
          } 
        } else {
          if (keywordList.indexOf(item.keyword) !== -1) {
            keywordList.splice(keywordList.indexOf(item.keyword), 1)
          } 
        }
      })
      
    }

    return {
      headConfig,
      getAppInfo,
      getSelectCountry,
      addForm,
      loading,
      selectStore,
      keywordList,
      addKeyword,
      addTagKeyword,
      addKeywordBtn,
      deleteTagKeyword,
      openAddKeyword,
      show,
      storeConfig,
      addFormInit,
      appSelect,
      appFirst,
      saveTagInput,
      blurInput,
      getShow,
      ...toRefs(newData),
      handleEdit,
      go,
      goService,
      searchAgain,
      rankDetail,
      rank,
      getWordRankTimer,
      getWordRankInit,
      isFromUserGuidance,
      goAppRank,
      checkAll, selectAll, isMaintain
    };
  },
  watch: {
    "addForm.region": {
      handler(val) {
        this.searchAgain(this.addForm);
        this.keywordList.length = 0;
      },
    },
    "addForm.platform": {
      handler(val) {
        this.searchAgain(this.addForm);
        this.keywordList.length = 0;
      },
    },
    "addForm.appId": {
      handler(val) {
        this.searchAgain(this.addForm);
        this.keywordList.length = 0;
      },
    },
  },
};
</script>

<style scoped lang="scss">
.state {
  width: 60px;
  text-align: center;
  :deep(.van-button--success){
    background: #6153ff;
    border:1px solid #6153ff;
  }
  :deep(.van-checkbox) {
    min-height: 35px;
    justify-content: center;
  }
}
.ranks {
  width: 120px;
}

@media screen and (max-width: 414px) {
  td.state {
    width: 30px;
  }
  td.ranks {
    width: auto;
  }
}


/deep/.van-field__control {
  background-color: #fff;
}
.titleOne {
  font-weight: 800;
}

.sucessBtn {
  width: 20px;
  border-radius: 15px;
}
.plusBtn {
  height: 20px;
  margin-bottom: 7px;
  border-radius: 15px;
}
table > thead {
  background-color: #f6f5ff;
  height: 34pt;
  padding: 24pt 0;
  border: #f6f5ff 1px solid;
}
.no-data {
  text-align: center;
  width: 100%;
}

.plusButton {
  background: #ccc;
  border: #ccc;
}
.active {
  color: #6153ff;
  font-weight: 800;
}
tbody tr td {
  border: 0.2px solid #ddd;
}
table tr {
  height: 24px;
}
table tr th {
  border: #f6f5ff;
}
table {
  width: 100%;
  min-height: 25px;
  line-height: 24px;
  text-align: center;
  border-collapse: collapse;
  padding: 2px;
}
.add-keyword {
  background: $bgColor;
  width: 100%;
  position: fixed;
  z-index: 10001;
  height: 100%;
  top: 0;
  left: 0;
  box-sizing: border-box;
  overflow-y: auto;
  overflow-x: hidden;

  .keyword-main {
    height: calc(100vh - 108px);
  }

  .select-all-items {
    margin-bottom: 8px;

    .van-cell {
      padding: 8px 10px;

      &::after {
        left: 10px;
        right: 10px;
      }

      :deep(.van-field__label) {
        flex: 1;
      }

      :deep(.van-field__value) {
        margin-right: 5px;

        ::-webkit-input-placeholder {
          color: #999;
        }
      }

      :deep(.van-cell__title) {
        color: #1e183f;
        font-weight: bold;
      }

      :deep(.van-cell__value) {
        font-size: 13px;

        span {
          color: #000;
        }
      }
    }
  }
  .keyword-table {
    background: #fff;

    .title {
      color: #1e183f;
      font-size: 14px;
      font-weight: bold;
      padding-top: 18px;
      padding-bottom: 10px;
      padding-left: 8px;
    }
  }

  .keyword-input {
    // height: calc(100vh - 222px);
    background: #fff;
    padding: 15px 10px 0;
    margin-bottom: 8px;

    .title {
      color: #1e183f;
      font-size: 14px;
      font-weight: bold;
      margin: 10px 0;
    }

    .input-area {
      flex-wrap: wrap;
      width: 100%;

      :deep(.van-cell) {
        padding: 0;
      }

      .input-tag {
        margin-right: 10px;
        margin-top: 10px;
        padding: 8px;
      }
    }

    .text-area-count {
      text-align: right;
      border-bottom: 1px solid #ebeef5;
      color: #ebeef5;
      padding-bottom: 8px;
    }

    .add-btn {
      width: 100%;
      margin-top: 15px;
      margin-bottom: 15px;
    }
  }
}
.table-class{
  overflow-x: auto;
  &>div{
    text-align: center;
    padding: 0 10px;
  }
  .keyword-table{
    width: 150%;
  }
}

.app-rank-more {
  height: 38px;
  text-align: center;
  line-height: 38px;
  border: 1px solid #EBEEF5;
  border-top: unset;
  font-size: 13px;
  font-family: Arial-Regular, Arial;
  font-weight: 400;
  color: #6153FF;
  &:hover {
    cursor: pointer;
    text-decoration: underline;
  }
}
</style>
